<template>
  <div class="guest-check-in-widget-wrapper">
    <div
      v-if="error_message"
      class="error-message"
    >
      <h2>Error Loading Form</h2>
      <p>{{ error_message }}</p>
    </div>

    <iframe
      v-else-if="widget_src"
      ref="widget-iframe"
      :src="widget_src"
      class="widget-iframe"
      title="Guest Check-In Form Widget"
      frameborder="0"
      @load="onIframeLoad"
    ></iframe>
    <div
      v-else
      class="loading-message"
    >
      <h2>Loading Guest Check-In Form...</h2>
    </div>
  </div>
</template>

<script>
import { buildWidgetUrl } from '@/js/widget/widget-url-builder.js';
import { PARENT_TO_WIDGET } from "@/js/widget/widget-messaging.js";

export default {
  name: 'GuestCheckInWidgetWrapper',

  data() {
    return {
      is_iframe_loaded: false,
      form_id: null,
      error_message: null
    };
  },

  computed: {
    widget_src() {
      const current_params = new URLSearchParams(window.location.search);
      const params = {};

      for (const [key, value] of current_params) {
        if (key !== 'form_id') {
          params[key] = value;
        }
      }

      return buildWidgetUrl('guest-check-in', params);
    }
  },

  mounted() {
    this.form_id = this.$route.params.guest_check_in_form_id;

    if (!this.form_id) {
      this.error_message = "No guest check-in form ID provided in the URL.";
      return;
    }

    document.title = 'Guest Check-In';
  },

  methods: {
    onIframeLoad() {
      this.is_iframe_loaded = true;

      if (this.error_message) {
        return;
      }

      if (this.form_id) {
        this.loadProductionModeData();
      }
    },

    loadProductionModeData() {
      const form_data_response = response => {
        const form_data = response;
        this.sendProductionData(form_data);
      };

      const error_handler = (error) => {
        const error_message = (error && error.message) ? error.message : "Unable to load guest check-in form.";
        this.error_message = error_message;
        this.postMessageToWidget({ error: error_message, form: null, params: null });
      };

      // Single API call that validates signature automatically
      const endpoint = `GET: api/v1/public/guest-check-in/form/${this.form_id}/published`;

      this.$rc.rest({
        spinner: true,
        endpoint: endpoint,
        on_success: form_data_response,
        on_error: error_handler
      });
    },

    sendProductionData(form_data) {
      const url_params = new URLSearchParams(window.location.search);
      const payload = {
        guest_check_in_form_id: this.form_id,
        is_test_submission: false,
        form: form_data,
        mobile_breakpoint: url_params.get("mobile") === "true" ? 0 : 600,
      };
      this.postMessageToWidget(payload);
    },

    postMessageToWidget(data) {
      const iframe = this.$refs['widget-iframe'];
      if (!iframe || !iframe.contentWindow) {
        return;
      }

      const message = [
        PARENT_TO_WIDGET.SET_SETTINGS,
        data
      ];

      iframe.contentWindow.postMessage(message, '*');
    }
  }
};
</script>

<style scoped>
.guest-check-in-widget-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.widget-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.error-message,
.loading-message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
}

.loading-message {
  background-color: #f5f5f5;
  color: #333;
}
</style>
